import {useI18n} from 'i18n/I18nContext'
import React, {ReactNode} from 'react'
import Form from 'react-bootstrap/Form'

export function SwitchInput(props: {
  value: boolean
  setFieldValue: (field: string, value: boolean) => void
  label: string
  name: string
  info?: ReactNode
}) {
  const {t} = useI18n()
  const {value, setFieldValue, name} = props

  const handleOnChange = () => {
    setFieldValue(name, !value)
  }

  return (
    <Form.Group className="mb-3 pb-2">
      <Form.Label>{props.label}</Form.Label>
      <Form.Switch
        label={value ? t('common.yes') : t('common.no')}
        onChange={handleOnChange}
        checked={value}
      />

      {props.info}
    </Form.Group>
  )
}
